import BaseModelAPI from '../BaseModelAPI';

export default class Line extends BaseModelAPI {
	static entity = 'line';
	static entityName = 'line';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.processTypeId = '';
			this.processType = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}